import useEmblaCarousel from "embla-carousel-react";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";

const PLACEHOLDERS = [
  { source: "Google Review", service: "Basement Waterproofing" },
  { source: "Facebook Review", service: "Concrete Driveway" },
  { source: "Google Review", service: "Foundation Repair" },
];

export default function Reviews() {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, align: "start" });

  return (
    <section id="reviews" data-testid="reviews-section" className="bg-[#0A0A0A] py-28 md:py-36 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <Reveal>
          <Overline>04 — Reviews</Overline>
          <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
            <h2 className="font-display text-4xl md:text-5xl font-semibold tracking-tight">
              What Our Customers Say
            </h2>
            <div className="flex gap-2">
              <button
                data-testid="reviews-prev-btn"
                onClick={() => emblaApi?.scrollPrev()}
                className="rounded-full border border-white/15 p-3 text-gray-300 hover:border-cyan-400 hover:text-cyan-400 transition-colors duration-200"
                aria-label="Previous review"
              >
                <ChevronLeft size={20} />
              </button>
              <button
                data-testid="reviews-next-btn"
                onClick={() => emblaApi?.scrollNext()}
                className="rounded-full border border-white/15 p-3 text-gray-300 hover:border-cyan-400 hover:text-cyan-400 transition-colors duration-200"
                aria-label="Next review"
              >
                <ChevronRight size={20} />
              </button>
            </div>
          </div>
        </Reveal>

        <Reveal>
          <div className="overflow-hidden" ref={emblaRef}>
            <div className="flex">
              {PLACEHOLDERS.map((r, i) => (
                <div key={i} className="min-w-0 shrink-0 grow-0 basis-full md:basis-1/2 lg:basis-1/3 px-2.5">
                  <article
                    data-testid={`review-card-${i}`}
                    className="glass-dark rounded-2xl p-8 h-full flex flex-col"
                  >
                    <Quote size={28} className="text-[#0066FF] mb-5" />
                    <div className="flex gap-1 mb-4">
                      {Array.from({ length: 5 }).map((_, s) => (
                        <Star key={s} size={16} className="text-[#D1D5DB]" fill="#D1D5DB" />
                      ))}
                    </div>
                    <p className="text-gray-400 text-sm leading-relaxed italic flex-1">
                      "This space is reserved for a verified customer review. Real Google and Facebook
                      reviews will appear here once imported — we never post fabricated feedback."
                    </p>
                    <div className="mt-6 pt-5 border-t border-white/10 flex items-center justify-between">
                      <div>
                        <p className="text-sm font-bold text-white">{r.source}</p>
                        <p className="text-xs text-gray-500 mt-0.5">{r.service}</p>
                      </div>
                      <span className="rounded-full bg-[#0066FF]/15 px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-cyan-400">
                        Import Pending
                      </span>
                    </div>
                  </article>
                </div>
              ))}
            </div>
          </div>
          <p className="mt-8 text-xs text-gray-600">
            Reviews are placeholders until live Google &amp; Facebook reviews are connected.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
